<template>
    <div v-if="visible" class="welcome-overlay">
        <div class="welcome-popup">
            <h3>{{ $t("welcome popup title") }}</h3>
            <p>{{ $t("welcome popup intro") }}</p>
            <div class="welcome-field">
                <label for="welcome_first_name">{{ $t("First Name") }}</label>
                <input
                    id="welcome_first_name"
                    type="text"
                    class="inputbtn btndefault btnblock"
                    v-model="firstName"
                />
            </div>
            <div class="welcome-field">
                <label for="welcome_email">{{ $t("Email address") }}</label>
                <input
                    id="welcome_email"
                    type="email"
                    class="inputbtn btndefault btnblock"
                    v-model="email"
                />
            </div>
            <label class="welcome-optin">
                <input type="checkbox" v-model="contactOptIn" />
                <span>{{
                    $t(
                        "If I don't finish my booking today, I'd like you to contact me to help"
                    )
                }}</span>
            </label>
            <div class="welcome-buttons">
                <button class="button" id="welcome_skip" @click.prevent="skip">
                    {{ $t("Skip") }}
                </button>
                <button
                    class="button blue"
                    id="welcome_continue"
                    :disabled="!canContinue"
                    @click.prevent="submitLead"
                >
                    {{ $t("Continue") }} &gt;&gt;
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
    name: "WelcomePopup",
    data() {
        return {
            visible: false,
            firstName: "",
            email: "",
            contactOptIn: false
        };
    },
    computed: {
        ...mapGetters(["getBookingDetails"]),
        canContinue() {
            return (
                this.firstName.trim() !== "" &&
                /^\S+@\S+\.\S+$/.test(this.email.trim())
            );
        }
    },
    methods: {
        close() {
            sessionStorage.setItem("shhWelcomeShown", "1");
            this.visible = false;
        },
        skip() {
            this.close();
        },
        submitLead() {
            const lead = {
                leadName: this.firstName.trim(),
                leadEmail: this.email.trim(),
                contactOptIn: this.contactOptIn
            };
            this.$store.commit("UPDATE_LEAD", lead);
            // the popup never blocks the booking: close immediately, persist in the background
            this.close();
            axios
                .post(process.env.VUE_APP_ROOT_URL + "booking/start", {
                    leadName: lead.leadName,
                    leadEmail: lead.leadEmail,
                    contactOptIn: lead.contactOptIn ? 1 : 0,
                    bid: this.getBookingDetails.bookingId
                })
                .then(response => {
                    if (response.data.saved && response.data.bookingId) {
                        this.$store.commit(
                            "UPDATE_BOOKING_ID",
                            response.data.bookingId
                        );
                    }
                })
                .catch(e => {
                    console.log(e);
                });
        }
    },
    mounted() {
        if (!sessionStorage.getItem("shhWelcomeShown")) {
            this.visible = true;
        }
    }
};
</script>

<style scoped>
.welcome-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
}
.welcome-popup {
    background: white;
    border-radius: 6px;
    padding: 25px;
    max-width: 480px;
    width: 100%;
    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.3);
}
.welcome-popup h3 {
    color: #00b8d3;
    margin-top: 0;
}
.welcome-field {
    margin-bottom: 12px;
}
.welcome-field label {
    display: block;
    font-weight: bold;
    margin-bottom: 3px;
}
/* the global .inputbtn styles size inputs for the wizard grid — force
   full width inside the popup */
.welcome-field input {
    width: 100% !important;
    max-width: 100%;
    box-sizing: border-box;
    display: block;
}
.welcome-optin {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 15px 0;
    font-size: 90%;
}
.welcome-optin input[type="checkbox"] {
    width: 18px;
    height: 18px;
    flex: 0 0 auto;
    margin-top: 2px;
}
.welcome-buttons {
    display: flex;
    justify-content: space-between;
    gap: 10px;
}
</style>
